import Config from 'config'
import AbstractService from './AbstractService'

export default class ReleasesService extends AbstractService {
  static search({
    pagesize,
    page,
    sort,
    filter,
    artist,
    title,
    label,
    version,
    genre,
    market,
    days,
    genres,
    markets,
    versions,
    release_types,
    packages,
    moods,
    instruments,
    explicit,
    archived
  }) {
    const params = {
      pagesize,
      page,
      sort,
      filter,
      artist,
      title,
      label,
      version,
      genre,
      market,
      days,
      genres,
      markets,
      versions,
      release_types,
      packages,
      moods,
      instruments,
      explicit
    }
    if (typeof archived === 'boolean') params.archived = archived
    return this.get(Config.endpoints.release, params)
  }

  static getOptions() {
    return this.get(Config.endpoints.options)
  }

  static getGenres() {
    return this.get(Config.endpoints.genres)
  }

  static getMarkets() {
    return this.get(Config.endpoints.markets, { color: 'dtw' })
  }

  static getLogos() {
    return this.get(Config.endpoints.logos)
  }

  static getDetail(releaseId) {
    return this.get(Config.endpoints.releaseDetail.replace('{0}', releaseId))
  }

  static archive(releaseId) {
    return this.post(Config.endpoints.archiveDetail.replace('{0}', releaseId))
  }
  static trackCommentingInit(releaseId) {
    return this.get(
      Config.endpoints.trackCommentingInit.replace('{0}', releaseId)
    )
  }
  static comment(releaseId, params) {
    return this.post(
      Config.endpoints.commentRelease.replace('{0}', releaseId),
      params
    )
  }

  static unArchive(releaseId) {
    return this.del(Config.endpoints.archiveDetail.replace('{0}', releaseId))
  }

  static getFlagged({ pagesize, page, sort, filter }) {
    const params = {
      pagesize,
      page,
      sort,
      filter
    }
    return this.get(Config.endpoints.flag, params)
  }
  static getArchived({ pagesize, page, sort, filter }) {
    const params = {
      pagesize,
      page,
      sort,
      filter
    }
    return this.get(Config.endpoints.archive, params)
  }
  static unFlagAll() {
    return this.delete(Config.endpoints.flag)
  }
  static flag(releaseId) {
    return this.post(Config.endpoints.flagDetail.replace('{0}', releaseId))
  }

  static unFlag(releaseId) {
    return this.del(Config.endpoints.flagDetail.replace('{0}', releaseId))
  }

  static flagSong(releaseId, songId) {
    return this.post(
      Config.endpoints.flagDetailTrack
        .replace('{0}', releaseId)
        .replace('{1}', songId)
    )
  }

  static unFlagSong(releaseId, songId) {
    return this.del(
      Config.endpoints.flagDetailTrack
        .replace('{0}', releaseId)
        .replace('{1}', songId)
    )
  }

  static getPdfLink(releaseid, format) {
    const route = Config.endpoints.releasePdf
      .replace('{0}', releaseid)
      .replace('{format}', format)
    return `${import.meta.env.VITE_BASE_URL}/${route}`
  }

  static shareRelease(releaseId, playersId = [], message = '') {
    return this._post({
      subdomain: null,
      url: Config.endpoints.shareRelease,
      data: {
        release_id: releaseId,
        players_id: playersId,
        message
      }
    })
  }
}
